import { z } from 'zod'

export const PriceBillingIntervalSchema = z.enum([
    'day',
    'week',
    'month',
    'year',
    'one_time',
])

export const CurrencyOptionSchema = z.object({
    amount: z.number(),
    compareAtAmount: z.number().optional(),
})

export const PriceSchema = z.object({
    id: z.string(),
    productId: z.string().nullable(),
    variantId: z.string().nullable(),
    accountId: z.string().nullable(),
    currencyOptions: z.record(z.string(), CurrencyOptionSchema),
    billingInterval: PriceBillingIntervalSchema.nullable().optional(),
    billingIntervalCount: z.number().nullable().optional(),
    trialPeriodDays: z.number().nullable().optional(),
    usageType: z.string().nullable().optional(),
    createdAt: z.date(),
    updatedAt: z.date(),
})

export const PriceWithVariantSchema = PriceSchema.extend({
    variant: z.object({
        id: z.string(),
        name: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
    }),
})

export const PriceWithProductSchema = PriceSchema.extend({
    variant: z.object({
        id: z.string(),
        name: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        product: z.object({
            id: z.string(),
            name: z.string(),
            description: z.string().nullable(),
        }),
    }),
})

export const PriceListItemSchema = PriceWithVariantSchema

export const PriceDetailsSchema = PriceWithProductSchema

export type PriceBillingIntervalType = z.infer<typeof PriceBillingIntervalSchema>
export type CurrencyOptionType = z.infer<typeof CurrencyOptionSchema>
export type PriceType = z.infer<typeof PriceSchema>
export type PriceWithVariantType = z.infer<typeof PriceWithVariantSchema>
export type PriceWithProductType = z.infer<typeof PriceWithProductSchema>
export type PriceListItemType = z.infer<typeof PriceListItemSchema>
export type PriceDetailsType = z.infer<typeof PriceDetailsSchema>

export const toPriceDto = (data: any): PriceType => {
    return PriceSchema.parse(data)
}

export const toPriceWithVariantDto = (data: any): PriceWithVariantType => {
    return PriceWithVariantSchema.parse(data)
}

export const toPriceWithProductDto = (data: any): PriceWithProductType => {
    return PriceWithProductSchema.parse(data)
}

export const toPriceListItemDto = (data: any): PriceListItemType => {
    return PriceListItemSchema.parse(data)
}

export const toPriceDetailsDto = (data: any): PriceDetailsType => {
    return PriceDetailsSchema.parse(data)
}

